<template>
  <v-card
    @click="goTo"
    :style="`background-color: ${data.color1_hex}`"
    :loading="isLoading"
    style="height: 100%"
  >
    <v-card-text>
      <v-img :src="data.logo" height="75" class="mb-4" contain></v-img>
      <div>
        <p class="text-center">
          <span class="text-body-1" :style="data.titleStyle">{{data.CompanyName}}</span>
          <br />
          <span class="text-caption" :style="data.titleStyle">{{data.shortDescription}}</span>
        </p>
      </div>
    </v-card-text>
    <v-card-actions v-if="cancel">
      {{message}}
      <v-spacer></v-spacer>
      <v-btn text @click.stop="cancel" color="error">Cancelar</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
function formatUrl (url) {
  if (url[url.length - 1] === '/') {
    return `${url}`
  } else {
    return `${url}/`
  }
}

export default {
  methods: {
    goTo () {
      this.onClick()
      localStorage.lastDistribuidor = JSON.stringify(this.data)
      window.location.assign(formatUrl(this.data.Url))
    }
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    cancel: {
      type: Function
    },
    message: {
      type: String
    },
    onClick: {
      type: Function,
      default: () => {}
    },
    isLoading: {
      type: Boolean,
      default: () => false
    }
  }
}
</script>
